// import { ThemeEvents, CartUpdateEvent } from '@theme/events';

// let pendingAddon = null;
// let running = false;

// function getAddonSelection(form) {
//   // If you have multiple blocks, this picks the checked one
//   const checkbox = document.querySelector('.addon-product-checkbox:checked');
//   if (!checkbox?.dataset?.addonId) return null;

//   const qtyInput = form.querySelector('[name="quantity"]');
//   const qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

//   return {
//     addonId: checkbox.dataset.addonId,
//     quantity: qty,
//     ts: Date.now(),
//   };
// }

// // Capture submit without blocking it
// document.addEventListener(
//   'submit',
//   (e) => {
//     const form = e.target?.closest?.('form[action*="/cart/add"]');
//     if (!form) return;

//     const selection = getAddonSelection(form);
//     if (!selection) return;

//     // Store intent: “when main item succeeds, add this”
//     pendingAddon = selection;
//   },
//   true
// );

// document.addEventListener(ThemeEvents.cartUpdate, async () => {
//   if (!pendingAddon || running) return;

//   // Expire quickly to avoid late execution
//   if (Date.now() - pendingAddon.ts > 6000) {
//     pendingAddon = null;
//     return;
//   }

//   running = true;

//   try {
//     // 1️⃣ Get current cart
//     const cart = await fetch('/cart.js').then(r => r.json());

//     // 2️⃣ Check if addon already exists
//     const addonExists = cart.items.some(
//       item => item.variant_id == pendingAddon.addonId
//     );

//     // 3️⃣ Add ONLY if not present
//     if (!addonExists) {
//       await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           id: pendingAddon.addonId,
//           quantity: 1 // ✅ always 1
//         })
//       });

//       // Refresh cart again after addon add
//       const updatedCart = await fetch('/cart.js').then(r => r.json());
//       document.dispatchEvent(
//         new CartUpdateEvent(updatedCart, 'addon-product', {
//           itemCount: updatedCart.item_count,
//           source: 'addon-product',
//           sections: {}
//         })
//       );
//     }

//   } catch (err) {
//     console.error('Addon logic failed:', err);
//   } finally {
//     pendingAddon = null;
//     running = false;
//   }
// });


// import { ThemeEvents, CartUpdateEvent } from '@theme/events';

// let pendingAddon = null;
// let running = false;

// /**
//  * Capture addon intent from form submit
//  */
// function getAddonSelection(form) {
//   const checkbox = document.querySelector('.addon-product-checkbox:checked');
//   if (!checkbox?.dataset?.addonId) return null;

//   const mainVariantInput = form.querySelector('[name="id"]');
//   if (!mainVariantInput?.value) return null;

//   return {
//     addonId: checkbox.dataset.addonId,          // addon variant
//     mainVariantId: mainVariantInput.value,      // main product variant
//     ts: Date.now()
//   };
// }

// /**
//  * Capture submit (do NOT block add to cart)
//  */
// document.addEventListener(
//   'submit',
//   (e) => {
//     const form = e.target?.closest?.('form[action*="/cart/add"]');
//     if (!form) return;

//     const selection = getAddonSelection(form);
//     if (!selection) return;

//     // Store intent
//     pendingAddon = selection;
//   },
//   true
// );

// /**
//  * After cart update → conditionally add addon
//  */
// document.addEventListener(ThemeEvents.cartUpdate, async () => {
//   if (!pendingAddon || running) return;

//   // Expire quickly (safety)
//   if (Date.now() - pendingAddon.ts > 6000) {
//     pendingAddon = null;
//     return;
//   }

//   running = true;

//   try {
//     // 1️⃣ Get current cart
//     const cart = await fetch('/cart.js').then(r => r.json());

//     // 2️⃣ Check: addon already added FOR THIS MAIN PRODUCT?
//     const addonExistsForThisProduct = cart.items.some(item =>
//       item.variant_id == pendingAddon.addonId &&
//       item.properties?._linked_product == pendingAddon.mainVariantId
//     );

//     // 3️⃣ Add addon only if NOT exists for this product
//     if (!addonExistsForThisProduct) {
//       await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           id: pendingAddon.addonId,
//           quantity: 1, // ✅ always 1
//           properties: {
//             _linked_product: pendingAddon.mainVariantId // 🔗 binding
//           }
//         })
//       });

//       // 4️⃣ Refresh cart + notify theme
//       const updatedCart = await fetch('/cart.js').then(r => r.json());

//       document.dispatchEvent(
//         new CartUpdateEvent(updatedCart, 'addon-product', {
//           itemCount: updatedCart.item_count,
//           source: 'addon-product',
//           sections: {}
//         })
//       );
//     }

//   } catch (err) {
//     console.error('Addon product logic failed:', err);
//   } finally {
//     pendingAddon = null;
//     running = false;
//   }
// });


import { ThemeEvents, CartUpdateEvent } from '@theme/events';

let pendingAddon = null;
let running = false;

/**
 * Capture addon intent
 */
function getAddonSelection(form) {
  const checkbox = document.querySelector('.addon-product-checkbox:checked');
  if (!checkbox?.dataset?.addonId) return null;

  const mainVariantInput = form.querySelector('[name="id"]');
  if (!mainVariantInput?.value) return null;

  return {
    addonId: checkbox.dataset.addonId,        // addon variant
    mainVariantId: mainVariantInput.value,    // main product variant
    ts: Date.now()
  };
}

/**
 * Capture submit
 */
document.addEventListener(
  'submit',
  (e) => {
    const form = e.target?.closest?.('form[action*="/cart/add"]');
    if (!form) return;

    const selection = getAddonSelection(form);
    if (!selection) return;

    pendingAddon = selection;
  },
  true
);

/**
 * Mark addon row with custom-addon-product-row
 */
async function markAddonItemsInCart() {
  const cart = await fetch('/cart.js').then(r => r.json());

  cart.items.forEach(item => {
    if (!item.properties?._is_addon) return;

    const row = document.querySelector(
      `.cart-items__table-row[data-key="${item.key}"]`
    );

    if (row) row.classList.add('custom-addon-product-row');
  });
}

/**
 * 🔥 FINAL ADDON LOGIC (PER PRODUCT +1 ONLY ONCE)
 */
document.addEventListener(ThemeEvents.cartUpdate, async () => {
  if (!pendingAddon || running) return;
  if (Date.now() - pendingAddon.ts > 6000) return;

  running = true;

  try {
    const cart = await fetch('/cart.js').then(r => r.json());

    // 🔍 Find existing addon row
    const existingAddon = cart.items.find(
      item => item.properties?._is_addon
    );

    if (existingAddon) {
      // Already addon row exists
      const linkedProducts = (
        existingAddon.properties._linked_products || ''
      )
        .split(',')
        .filter(Boolean);

      // ❌ Same product again → do nothing
      if (linkedProducts.includes(pendingAddon.mainVariantId)) {
        pendingAddon = null;
        running = false;
        return;
      }

      // ✅ New product → +1
      linkedProducts.push(pendingAddon.mainVariantId);

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: existingAddon.key,
          quantity: existingAddon.quantity + 1,
          properties: {
            ...existingAddon.properties,
            _linked_products: linkedProducts.join(',')
          }
        })
      });

    } else {
      // First addon ever
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: pendingAddon.addonId,
          quantity: 1,
          properties: {
            _is_addon: true,
            _linked_products: pendingAddon.mainVariantId
          }
        })
      });
    }

    const updatedCart = await fetch('/cart.js').then(r => r.json());

    document.dispatchEvent(
      new CartUpdateEvent(updatedCart, 'addon-product', {
        itemCount: updatedCart.item_count,
        source: 'addon-product',
        sections: {}
      })
    );

    setTimeout(markAddonItemsInCart, 100);

  } catch (e) {
    console.error('Addon logic failed', e);
  } finally {
    pendingAddon = null;
    running = false;
  }
});

/**
 * Initial render
 */
document.addEventListener('DOMContentLoaded', markAddonItemsInCart);
document.addEventListener(ThemeEvents.cartUpdate, markAddonItemsInCart);





